// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__16OGO","footer":"ModalUpdate_footer__g1868"};